import request from "@/service";

/* 查询音频集列表 */
export function audioSetList(data) {
  return request({
    url: `/resource/audio/set/page`,
    method: "get",
    params: data
  });
}

/* 根据音频名称模糊匹配获取视频列表 */
export function getAudioListByName(data) {
  return request({
    url: `/resource/audio/set/getAudioPageByName`,
    method: "get",
    params: data
  });
}

/* 查询无关联视频列表 */
export function getNoRAudio(data) {
  return request({
    url: `/resource/audio/set/getNoRAudio`,
    method: "get",
    params: data
  });
}

/* 新增音频集 */
export function audioSetSave(data) {
  return request({
    url: `/resource/audio/set/save`,
    method: "post",
    data
  });
}

/* 更新音频集信息 */
export function audioSetUpdate(data) {
  return request({
    url: `/resource/audio/set/update`,
    method: "put",
    data
  });
}

/* 批量删除音频集 */
export function audioSetDelete(data) {
  return request({
    url: `/resource/audio/set/delete`,
    method: "delete",
    data
  });
}

// 关联视频移除
export function deleteRelation(data) {
  return request({
    url: `/resource/video/set/deleteRelation`,
    method: "delete",
    data
  });
}

/* 上下线 */
export function changeOnlineStatus(data) {
  return request({
    url: `/resource/audio/set/online`,
    method: "post",
    data
  });
}

/* 上下移动 */
export function upAndDown(data) {
  return request({
    url: `/resource/video/set/upAndDown`,
    method: "post",
    data
  });
}

/* 根据音频集获取音频列表 */
export function getAudioList(data) {
  return request({
    url: `/resource/audio/set/audioList/${data.uuid}`,
    method: "get"
  });
}

/* 视频列表 */
export function saveRelation(data) {
  return request({
    url: `/resource/video/set/saveRelation`,
    method: "post",
    data
  });
}
/* 获取音频集详情 */
export function getAudiosetInfo(data) {
  return request({
    url: `/resource/audio/set/info/${data.uuid}`,
    method: "get"
  });
}

// 音频集共享记录
export function audioSetSharePage(data) {
  return request({
    url: `/resource/audio/set/sharePage`,
    method: "get",
    params: data
  });
}

// 恢复音频集
export function recoveryAudioSet(data) {
  return request({
    url: `/resource/audio/set/recoveryAudioSet`,
    method: "put",
    data
  });
}

// 音频集共享
export function shareAudioSet(data) {
  return request({
    url: `/resource/audio/set/shareAudioSet`,
    method: "put",
    data
  });
}

// 取消音频集共享
export function cancelShareAudioSet(data) {
  return request({
    url: `/resource/audio/set/cancelShareAudioSet`,
    method: "put",
    data
  });
}

// 音频集一键共享
export function shareAllAudioSet(data) {
  return request({
    url: `/resource/audio/set/shareAllAudioSet`,
    method: "put",
    data
  });
}

// 导入图书
export function importAudioSet(params) {
  return request({
    url: `/resource/audio/set/import`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/foresource-data; boundary=----WebKitForesourceBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}
